<app-dialog
  headerText="Constraints"
  [body]="body"
  [showCancelButton]="true"
  cancelText="Close"
  [showSaveButton]="false"
  [showTopCancelButton]="true"
></app-dialog>

<ng-template #body>
  <div class="constraints-container">
    @if (!!source && source === "create") {
      <div>Specifies all the constraints for creating this resource.</div>
    }
    @if (!!source && source === "edit") {
      <div>Specifies all the constraints for updating this resource.</div>
    }
    @if (!!source && source === "delete") {
      <div>Specifies all the constraints for deleting this resource.</div>
    }
    @if (!source) {
      <div>
        Specifies all the constraints for the selected action and resource.
      </div>
    }
    <div>
      Each constraint set specifies whether all or at least one of the
      constraints contained within the set must be met for the action to be
      valid. If more than one constraint set is listed, then all sets must be
      met for the action to be valid.
    </div>

    <div class="data-container">
      <div>
        <span>Action: </span><span class="value">{{ data.action }}</span>
      </div>
      <div>
        <span>Group: </span><span class="value">{{ data.group }}</span>
      </div>
      <div>
        <span>Type: </span><span class="value">{{ data.type }}</span>
      </div>
      <div>
        <span>Name: </span><span class="value">{{ data.name }}</span>
      </div>
    </div>

    <fd-tab-list class="constraint-tabs" [stackContent]="true">
      @for (tab of constraintSets; track tab) {
        <fd-tab [title]="tab.title">
          <h3 class="section-title">{{ tab.title }}</h3>
          <div class="constraints-unit-rule">
            <b>{{ tab.rulePrefixText }}</b> of the constraints in this set must
            be met:
          </div>
          <app-container [body]="tmp"></app-container>
          <ng-template #tmp>
            <div class="constraints-unit-container">
              @for (
                constraint of tab.constraints;
                track constraint;
                let last = $last
              ) {
                <div class="constraints-unit">
                  <div class="constraints-row">
                    <div class="label">PolicyMetadata:</div>
                    <div class="value">{{ constraint.type }}</div>
                  </div>
                  <div class="constraints-row">
                    <div class="label">Description:</div>
                    <div class="value">{{ constraint.description }}</div>
                  </div>
                  <div class="constraints-row">
                    <div class="label">Parameters:</div>
                    <div class="value">
                      {{ JSON.stringify(constraint.parameters) }}
                    </div>
                  </div>
                  @if (!last) {
                    <div class="border-line"></div>
                  }
                </div>
              }
            </div>
          </ng-template>
        </fd-tab>
      }
    </fd-tab-list>
  </div>
</ng-template>
